export const RED_BRIGHT = '#E92200';
